<template>
  <div class="mx-[40px] my-[30px]">
    <div class="text-font-1 font-bold">
      {{
        $t('qi-ye-nei-wu-ke-zhuan-rang-dui-xiang-qing-xian-yao-qing-cheng-yuan')
      }}
    </div>
    <div class="mt-[15px] bg-back-3 p-[16px] rounded-[8px]">
      <div>
        <div class="text-12 text-font-70 mb-[10px]">
          {{
            $t(
              'fu-zhi-yi-xia-lian-jie-cheng-yuan-dian-ji-lian-jie-zhu-ce-deng-lu-hou-jia-ru-tuan-dui'
            )
          }}
        </div>
        <ShareLink bg="!bg-back-1" :hasTitle="false" :url="link" />
        <div class="text-12 text-font-50 mt-[20px]">
          <span v-if="info?.is_expired" class="text-red-600">
            {{
              $t('dang-qian-tao-can-yi-guo-qi-qing-xu-fei-hou-ji-xu-shi-yong')
            }}
          </span>
        </div>
      </div>
    </div>
    <div class="mt-[12px] text-font-60">
      <span class="text-error">*</span>
      {{ $t('ru-you-qi-ta-wen-ti-qing-lian-xi-nin-de-shang-wu-fu-ze-ren') }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import { createInvitation } from '~/api'
import { ShareLink } from '~/features/template/components/shareLink'

const link = ref('')

const props = defineProps<{ info: any }>()

const openChange = async () => {
  if (props.info?.value?.is_expired) {
    return
  }

  try {
    const res = await createInvitation()
    if (res.code === 0) {
      link.value = `${location.origin}/center/invite?token=${res.data.token}`
    }
  } catch (error) {
    console.error(error)
  }
}

openChange()
</script>
